(function () {
  var MODEL_PREFIXES = [
    'iphone-', 'ipad-', 'galaxy-', 'redmi-', 'xiaomi-', 'huawei-', 'oppo-', 'realme-',
    'poco-', 'motorola-', 'apple-watch-', 'galaxy-watch-', 'mi-band-', 'redmi-watch-',
    'huawei-watch-', 'amazfit-', 'garmin-', 'fitbit-', 'honor-watch-',
  ];

  var STRICT_MODEL_COLLECTIONS = ['col-capas', 'col-peliculas', 'col-relogios'];

  var BRAND_TAGS = [
    'iphone', 'ipad', 'samsung', 'xiaomi', 'redmi', 'huawei', 'oppo', 'realme',
    'apple', 'amazfit', 'garmin', 'fitbit', 'honor', 'google', 'motorola', 'poco',
  ];

  function modelTags(tags) {
    return (tags || []).filter(function (t) {
      var tag = String(t).toLowerCase();
      return MODEL_PREFIXES.some(function (p) {
        return tag.indexOf(p) === 0;
      });
    });
  }

  function brandTags(tags) {
    return (tags || []).filter(function (t) {
      return BRAND_TAGS.indexOf(String(t).toLowerCase()) !== -1;
    });
  }

  function requiresStrictModel(tags) {
    return STRICT_MODEL_COLLECTIONS.some(function (col) {
      return (tags || []).indexOf(col) !== -1;
    });
  }

  function itemModelTags(item) {
    if (item.models && item.models.length) return item.models;
    return modelTags(item.tags || []);
  }

  function sharesModel(sourceModels, sourceBrands, item) {
    var targetModels = itemModelTags(item);
    if (sourceModels.length && targetModels.length) {
      return sourceModels.some(function (m) {
        return targetModels.indexOf(m) !== -1;
      });
    }
    if (sourceModels.length || targetModels.length) {
      return false;
    }
    if (!sourceBrands.length) return false;
    var targetBrands = brandTags(item.tags || []);
    return sourceBrands.some(function (b) {
      return targetBrands.indexOf(b) !== -1;
    });
  }

  function titleMatches(title, needles) {
    if (!needles || !needles.length) return true;
    var t = String(title || '').toLowerCase();
    return needles.some(function (n) {
      return t.indexOf(String(n).toLowerCase()) !== -1;
    });
  }

  function ruleMatches(rule, productTags, productTitle) {
    var tags = productTags || [];
    var any = rule.when_any_tags || [];
    var all = rule.when_all_tags || [];
    if (any.length && !any.some(function (t) { return tags.indexOf(t) !== -1; })) return false;
    if (all.length && !all.every(function (t) { return tags.indexOf(t) !== -1; })) return false;
    if (!titleMatches(productTitle, rule.when_title_any)) return false;
    return true;
  }

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
    } catch (e) {
      return value + ' €';
    }
  }

  function mapShopifyProduct(p) {
    return {
      handle: p.handle,
      title: p.title,
      url: p.url,
      image: (p.featured_image && (p.featured_image.url || p.featured_image)) || '',
      price: (p.price_min || p.price || 0) / 100,
    };
  }

  function renderCard(item) {
    var a = document.createElement('a');
    a.className = 'tek-crosssell__card';
    a.href = item.url;
    var img = document.createElement('img');
    img.className = 'tek-crosssell__img';
    img.loading = 'lazy';
    img.alt = item.title || '';
    if (item.image) img.src = item.image;
    var body = document.createElement('div');
    body.className = 'tek-crosssell__body';
    var t = document.createElement('p');
    t.className = 'tek-crosssell__title';
    t.textContent = item.title || '';
    var p = document.createElement('p');
    p.className = 'tek-crosssell__price';
    p.textContent = formatPrice(item.price || 0);
    body.appendChild(t);
    body.appendChild(p);
    a.appendChild(img);
    a.appendChild(body);
    return a;
  }

  function renderItems(root, headingText, items) {
    if (!items.length) {
      root.hidden = true;
      return;
    }
    var heading = root.querySelector('.tek-crosssell__heading');
    if (heading) heading.textContent = headingText || 'Também te pode interessar';
    var grid = root.querySelector('.tek-crosssell__grid');
    if (!grid) return;
    grid.innerHTML = '';
    items.forEach(function (item) {
      grid.appendChild(renderCard(item));
    });
    root.hidden = false;
  }

  function fetchRecommendations(productId, intent) {
    if (!productId) return Promise.resolve([]);
    var url =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=8&intent=' +
      encodeURIComponent(intent || 'related');
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('recommendations failed');
        return r.json();
      })
      .then(function (data) {
        return (data.products || []).map(mapShopifyProduct);
      })
      .catch(function () {
        return [];
      });
  }

  function shouldMatchModel(rule, productTags) {
    if (rule.match_model_tag) return true;
    return requiresStrictModel(productTags);
  }

  function itemsFromRules(rulesDoc, catalogDoc, productTags, productTitle, productHandle, models, brands) {
    var rules = rulesDoc.rules || [];
    var catalog = catalogDoc.rules || {};
    var matched = rules.filter(function (rule) {
      return ruleMatches(rule, productTags, productTitle);
    });
    if (!matched.length) return { items: [], heading: '' };

    var items = [];
    var seen = {};
    matched.forEach(function (rule) {
      var pool = catalog[rule.id] || [];
      var matchModel = shouldMatchModel(rule, productTags);
      pool.forEach(function (item) {
        if (item.handle === productHandle || seen[item.handle]) return;
        if (matchModel && !sharesModel(models, brands, item)) return;
        seen[item.handle] = true;
        items.push(item);
      });
    });

    return {
      items: items,
      heading: matched[0].label || 'Combina bem com',
    };
  }

  function init(root) {
    var ctxEl = document.getElementById('tek-crosssell-context');
    if (!ctxEl || !root) return;

    var ctx;
    try {
      ctx = JSON.parse(ctxEl.textContent || '{}');
    } catch (e) {
      return;
    }

    var productTags = ctx.product_tags || [];
    var productTitle = ctx.product_title || '';
    var productHandle = ctx.product_handle || '';
    var productId = ctx.product_id;
    var models = modelTags(productTags);
    var brands = brandTags(productTags);
    var strictModel = requiresStrictModel(productTags);
    var limit = parseInt(root.dataset.limit || '8', 10);

    Promise.all([
      fetch(root.dataset.rulesUrl).then(function (r) { return r.json(); }),
      fetch(root.dataset.catalogUrl).then(function (r) { return r.json(); }),
    ])
      .then(function (res) {
        var picked = itemsFromRules(
          res[0],
          res[1],
          productTags,
          productTitle,
          productHandle,
          models,
          brands
        );
        var items = picked.items.slice(0, limit);
        if (items.length) {
          renderItems(root, picked.heading, items);
          return;
        }
        if (strictModel) {
          root.hidden = true;
          return;
        }
        return fetchRecommendations(productId, 'complementary').then(function (fallback) {
          if (!fallback.length) {
            return fetchRecommendations(productId, 'related');
          }
          return fallback;
        }).then(function (fallback) {
          renderItems(root, 'Também te pode interessar', fallback.slice(0, limit));
        });
      })
      .catch(function () {
        if (strictModel) {
          root.hidden = true;
          return;
        }
        fetchRecommendations(productId, 'related').then(function (fallback) {
          renderItems(root, 'Também te pode interessar', fallback.slice(0, limit));
        });
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tek-crosssell]').forEach(init);
  });
})();
